var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_83696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9928 5.37553 18.6245 0.00717187 12 0ZM16 14.587C16.4063 14.961 16.4326 15.5936 16.0586 16C15.6846 16.4063 15.0519 16.4326 14.6456 16.0586C14.6252 16.0399 14.6057 16.0203 14.587 16L12 13.414L9.414 16C9.01673 16.3837 8.38369 16.3726 8.00002 15.9754C7.62577 15.5879 7.62577 14.9735 8.00002 14.586L10.586 12L8.00002 9.414C7.61634 9.01673 7.62736 8.38369 8.02462 8.00002C8.41214 7.62577 9.02648 7.62577 9.414 8.00002L12 10.586L14.587 8.00002C14.961 7.59366 15.5936 7.56741 16 7.94142C16.4063 8.31544 16.4326 8.94806 16.0586 9.35442C16.0399 9.37477 16.0203 9.39427 16 9.41302L13.414 12L16 14.587Z",
    fill: "#70798E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_83696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b0c70aa43938ab8c4961a7a09f3f679f.svg";
export { ForwardRef as ReactComponent };